import { IVoucherSimulationAnnualResult } from "./voucher-simulation-annual-result";

export interface IVoucherSimulationSummary {
    year: number,
    growthRate: string,
    growthRateVariability: string,
    selectedPercentile: number,
    selectedSimNumber: number,
    selectedChainStarts: number,
    selectedChainStartsO: number,
    selectedChainEndsNeeded: number,
    selectedChainEndsNeededO: number,
    selectedCoverage: string,
    selectedCoverageO: string,
    coverageMin: string,
    coverageOMin: string,
    coverage75: string,
    coverageO75: string,
    coverage50: string,
    coverageO50: string,
    coverage25: string,
    coverageO25: string,
    coverageMax: string,
    coverageOMax: string,
    sortedRunsList: IVoucherSimulationAnnualResult[]
}

